module.exports = "<app-navbar></app-navbar>\r\n<app-alert></app-alert>\r\n<router-outlet></router-outlet>"